module.exports = __webpack_public_path__ + "static/media/icon-4.1fe6a245.svg";